import "./SectionThreeSlider.css";

import React from "react";

import { useRef, useEffect, useState } from "react";

import { SectionThreeSliderCard } from "./SectionThreeSliderCard";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

export const SectionThreeSlider = ({ sliderItems }) => {
  const [riseizeTracker, setRiseizeTracker] = useState(1);

  const [sliderItemsData, setSliderItemsData] = useState([]);
  let counter = 0;

  const sliderContent = useRef(null);
  const sliderContainer = useRef(null);
  const buttonForward = useRef(null);
  const buttonBack = useRef(null);

  const handleSliderForward = () => {
    sliderContent.current.style.transition = `all 1s`;
    counter = counter + 1;
    buttonBack.current.style.pointerEvents = "all";
    buttonBack.current.style.opacity = "1";
    let translateIndex = counter * 18;
    sliderContent.current.style.transform = `translateX(${translateIndex}rem)`;
    if (counter === 0) {
      buttonForward.current.style.pointerEvents = "none";
      buttonForward.current.style.opacity = "0.3";
    }
  };
  const handleSliderBack = () => {
    sliderContent.current.style.transition = `all 1s`;
    counter = counter - 1;
    buttonForward.current.style.pointerEvents = "all";
    buttonForward.current.style.opacity = "1";
    let translateIndex = counter * 18;
    sliderContent.current.style.transform = `translateX(${translateIndex}rem)`;
    let responsiveSlidelimit = 0;
    if (window.innerWidth <= 615) {
      responsiveSlidelimit = 0;
    } else if (window.innerWidth <= 900) {
      responsiveSlidelimit = 1;
    } else if (window.innerWidth <= 1115) {
      responsiveSlidelimit = 2;
    } else {
      responsiveSlidelimit = 3;
    }
    if (counter === -sliderItems.length + responsiveSlidelimit) {
      sliderContent.current.style.transform = `translateX(0rem)`;
      counter = 0;
      buttonForward.current.style.pointerEvents = "none";
      buttonForward.current.style.opacity = "0.3";
    }
  };
  window.onresize = () => {
    setRiseizeTracker((old) => old + 1);
  };
  useEffect(() => {
    if (window.innerWidth <= 615) {
      if (sliderItems.length <= 1) {
        buttonForward.current.style.pointerEvents = "none";
        buttonForward.current.style.opacity = "0.3";
        buttonBack.current.style.pointerEvents = "none";
        buttonBack.current.style.opacity = "0.3";
      } else {
        buttonForward.current.style.pointerEvents = "all";
        buttonForward.current.style.opacity = "1";
        buttonBack.current.style.pointerEvents = "all";
        buttonBack.current.style.opacity = "1";
      }
    } else if (window.innerWidth <= 900) {
      if (sliderItems.length <= 2) {
        buttonForward.current.style.pointerEvents = "none";
        buttonForward.current.style.opacity = "0.3";
        buttonBack.current.style.pointerEvents = "none";
        buttonBack.current.style.opacity = "0.3";
      } else {
        buttonForward.current.style.pointerEvents = "all";
        buttonForward.current.style.opacity = "1";
        buttonBack.current.style.pointerEvents = "all";
        buttonBack.current.style.opacity = "1";
      }
    } else if (window.innerWidth <= 1115) {
      if (sliderItems.length <= 3) {
        buttonForward.current.style.pointerEvents = "none";
        buttonForward.current.style.opacity = "0.3";
        buttonBack.current.style.pointerEvents = "none";
        buttonBack.current.style.opacity = "0.3";
      } else {
        buttonForward.current.style.pointerEvents = "all";
        buttonForward.current.style.opacity = "1";
        buttonBack.current.style.pointerEvents = "all";
        buttonBack.current.style.opacity = "1";
      }
    } else {
      if (sliderItems.length <= 4) {
        buttonForward.current.style.pointerEvents = "none";
        buttonForward.current.style.opacity = "0.3";
        buttonBack.current.style.pointerEvents = "none";
        buttonBack.current.style.opacity = "0.3";
      } else {
        buttonForward.current.style.pointerEvents = "all";
        buttonForward.current.style.opacity = "1";
        buttonBack.current.style.pointerEvents = "all";
        buttonBack.current.style.opacity = "1";
      }
    }
    counter = 0;
    sliderContent.current.style.transition = "all 0.1s ease-out";
    sliderContent.current.style.transition = "transform 0s";
    sliderContent.current.style.opacity = "0";
    setTimeout(() => {
      setSliderItemsData(sliderItems);
      sliderContent.current.style.transform = `translateX(0rem)`;
    }, 100);
    setTimeout(() => {
      sliderContent.current.style.transition = "opacity 0.25s ease-out";
      sliderContent.current.style.opacity = "1";
    }, 150);

    buttonForward.current.style.pointerEvents = "none";
    buttonForward.current.style.opacity = "0.3";
  }, [sliderItems, riseizeTracker]);
  return (
    <div className="section-three-slider-container">
      <div className="section-three-slider-forward-button">
        <button
          className="button1"
          ref={buttonForward}
          onClick={handleSliderForward}
        >
          <ArrowBackIosNewIcon />
        </button>
      </div>

      <div ref={sliderContainer} className="slider-container">
        <div ref={sliderContent} className="slider-content">
          {sliderItems.map((item) => {
            return (
              <SectionThreeSliderCard
                key={item.id}
                itemId={item.id}
                isOnSale={item.isOnSale}
                imgSrc={item.imgId1}
                name={item.name}
                description={item.description}
                price={item.price}
                oldPrice={item.oldPrice}
              />
            );
          })}
        </div>
      </div>
      <div className="section-three-slider-back-button">
        <button className="button2" ref={buttonBack} onClick={handleSliderBack}>
          <ArrowForwardIosIcon />
        </button>
      </div>
    </div>
  );
};
